import { GuardRedirect } from 'commons/components/guard/guard-redirect.component';
import { Guard, GuardService } from 'commons/components/guard/guard.component';
import { FEATURE_FLAGS_NAMES, FeatureFlag } from 'core/service/feature-flag/feature-flag.model';
import { useFeatureFlagsContext } from 'core/contexts/feature-flags/hooks/use-feature-flags-context.hook';

interface FeatureFlagGuardProps {
    featureFlag: FEATURE_FLAGS_NAMES;
    children: React.ReactNode;
    redirect?: string;
}

const FeatureFlagGuard = ({ children, featureFlag, redirect = undefined }: FeatureFlagGuardProps) => {
    const { featureFlags } = useFeatureFlagsContext();

    const guardService: GuardService<FEATURE_FLAGS_NAMES> = {
        checkPermissions: (feature) =>
            featureFlags?.find((flag: FeatureFlag) => flag.name === feature)?.active ?? false,
    };

    const FeatureGuard = redirect ? GuardRedirect : Guard;

    return (
        <FeatureGuard guardService={guardService} requiredPermissions={featureFlag} redirect={redirect}>
            {children}
        </FeatureGuard>
    );
};

export default FeatureFlagGuard;
